import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { SummaryDashboardService } from 'src/app/shared/services/summary-dashboard.service';
import { Chart,registerables } from 'chart.js';
import * as moment from 'moment';
import { StatusBadgeRendererComponent } from 'src/app/shared/common/status-badge-renderer';
Chart.register(...registerables);
@Component({
    selector: 'app-summary-dashboard',
    templateUrl: './summary-dashboard.component.html',
    styleUrls: ['./summary-dashboard.component.scss'],
    standalone: false
})
export class SummaryDashboardComponent implements OnInit {

  backgroundColorScreen;
  filterOptions: string[] = ['Today', 'This Week', 'This Month', 'This Year'];
  selectedFilter = 'Today';
  today: Date = new Date();
  startDate: any | null = null;
  endDate: any | null = null; 
  rangeStartDate: any | null = null;
  rangeEndDate: any | null = null;
  activityOptions=['Extraction','Transform','Load']
  selectedActivity='Extraction'

  gridApi;
  columnDefs;
  defaultColDef;
  paginationPageSize;
  paginationNumberFormatter;
  rowClassRules;
  getdata;


  doughnutData = {
    labels: [
      'Completed',
      'Failed',
      'Inprogress'
    ],
    datasets: [{
      label: 'Object Count',
      data: [],
      backgroundColor: [
        'rgb(54, 162, 235)',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)'
      ],
      hoverOffset: 4
    }]
  };
  doughnutConfig:any = {
    type: 'doughnut',
    data: this.doughnutData,
    options:{
      responsive: true,
      maintainAspectRatio: false, 
      // cutout: '80%'
      plugins: {
        legend: {
          position: 'bottom'
        },
        title: {
          display: true, // 👈 must be true to show title
          text: 'Objects State',
          font: {
            size: 16,
            weight: 'bold'
          },
          padding: {
            top: 0,
            bottom: 10
          },
          align: 'center' // or 'start' | 'end'
        }
      }
    }
  };
  doughnutChart:any;

  
  barchartData:any= {
  labels: [],
  datasets: [{
    label: 'Success Count',
    data: [],
    backgroundColor: [
      'rgba(54, 162, 235)',
    ],
    borderColor: [
      'rgb(54, 162, 235)',
    ],
    borderWidth: 1,
    barThickness: 20
  },
  {
    label: 'Failed Count',
    data: [],
    backgroundColor: [
      'rgba(255, 99, 132)',
    ],
    borderColor: [
      'rgb(255, 99, 132)',
    ],
    borderWidth: 1,
    barThickness: 20
  }
]
};
barchartConfig:any = {
  type: 'bar',
  data: this.barchartData,
  options: {
    scales: {
      y: {
        beginAtZero: true
      },
      x: {
        // For vertical bars
        ticks: {
          autoSkip: false
        },
        grid: {
          display: false
        }
      }
      
    },
    plugins: {
      legend: {
        position: 'bottom'
      },
      title: {
        display: true, // 👈 must be true to show title
        text: 'Objects Record Count',
        font: {
          size: 16,
          weight: 'bold'
        },
        padding: {
          top: 0,
          bottom: 10
        },
        align: 'center' // or 'start' | 'end'
      }
    },
    responsive: true,
    maintainAspectRatio: false, 
  },
};

barChart:any;

lineChart:any;
components;

  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private spinner: NgxUiLoaderService,
    private constants: constants,
    private snackbar: MatSnackBar,
    private service:SummaryDashboardService
  ) { 
    this.components = {
      statusBadge:StatusBadgeRendererComponent
    }
  }
 
  ngOnInit(): void {
   if(this.selectedFilter == "Today"){
    const today = new Date();
    this.startDate=moment(today).format('YYYY-MM-DD')
     this.endDate=moment(today).format('YYYY-MM-DD')
   }
   
    // this.lineChart=new Chart('lineChartId',this.lineChartConfig)
    this.columnDefs = [
      { headerName: 'Migration Id', headerTooltip: 'Migration Id', tooltipValueGetter: (params) => 'Migration Id : ' + params.value, field: 'migrationid', filter: 'agTextColumnFilter', width: 100 },
      { headerName: 'Time Taken', headerTooltip: 'Time Taken', tooltipValueGetter: (params) => 'Time Taken : ' + params.value, field: 'duration', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'State', 
        headerTooltip: 'State',
        cellRenderer:"statusBadge",
         tooltipValueGetter: (params) => 'State : ' + params.value, field: 'state', 
         filter: 'agTextColumnFilter', 
         width: 120 
        },
      { headerName: 'Total Object Count', headerTooltip: 'Total Object Count', tooltipValueGetter: (params) => 'Total Object Count : ' + params.value, field: 'totalObjectCount', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Completed Object Count', headerTooltip: 'Completed Object Count', tooltipValueGetter: (params) => 'Completed Object Count : ' + params.value, field: 'completedObjectCount', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Failed Object Count', headerTooltip: 'Failed Object Count', tooltipValueGetter: (params) => 'Failed Object Count : ' + params.value, field: 'failedObjectCount', filter: 'agTextColumnFilter', width: 120 },
      { headerName: 'Inprogress Object Count', headerTooltip: 'Inprogress Object Count', tooltipValueGetter: (params) => 'Inprogress Object Count : ' + params.value, field: 'inprogressObjectCount', filter: 'agTextColumnFilter', width: 120 }
      
    ]
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    // this.paginationPageSize = this.constants.pagesize;
    // this.paginationNumberFormatter = function (params) {
    //   return params.value.toLocaleString();
    // };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
  }

  onGridReady(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
    let filterData={
      "startDate": this.startDate,
      "endDate": this.endDate,
      "activity": this.selectedActivity
    }
    this.spinner.start();
    this.service.retreiveETLMigrationCount(filterData).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.doughnutData.datasets[0].data=[]
        this.doughnutChart=new Chart('doughnutChartId',this.doughnutConfig)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        let totalCompletedObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.completedObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        let totalFailedObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.failedObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        let totalInProgressObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.inprogressObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        this.doughnutData.labels=[  'Completed '+totalCompletedObjectCount,'Failed '+totalFailedObjectCount, 'Inprogress '+totalInProgressObjectCount]
        this.doughnutData.datasets[0].data=[totalCompletedObjectCount,totalFailedObjectCount,totalInProgressObjectCount]
        this.doughnutChart=new Chart('doughnutChartId',this.doughnutConfig)
        // let loadfilterData={
        //   "startDate": filterData.startDate,
        //   "endDate": filterData.endDate,
        // }
        this.generateLinechart()
        this.service.retreiveLoadObjectsCount(filterData).subscribe(res=>{
          if(res.error == true){
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", {
              duration: 5000,
            });
            this.barchartData.labels=[]
            this.barchartData.datasets[0].data=[]
            this.barchartData.datasets[1].data=[]
            this.barChart=new Chart('barchartId',this.barchartConfig)
          }else{
            console.log(res)
            let data:any=res
            data.forEach(item=>{
              this.barchartData.labels.push(item.objectname)
              this.barchartData.datasets[0].data.push(item.totalSuccesscount)
              this.barchartData.datasets[1].data.push(item.totalFailcount)
            })
            this.barChart=new Chart('barchartId',this.barchartConfig)
          }
        })
        this.spinner.stop();
      }
     
    })
  }
  selectFilter(item: string): void {
    this.selectedFilter = item;
    const today = new Date();
    console.log('Selected:', item);
    // Today This Week This Month This Year
    // Emit an event or call logic here
    if(item == "Today"){
     this.startDate=moment(today).format('YYYY-MM-DD')
     this.endDate=moment(today).format('YYYY-MM-DD')
    }else if(item == "This Week"){
      const dayOfWeek = today.getDay();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));
      this.startDate=moment(startOfWeek).format('YYYY-MM-DD');
      this.endDate=moment(today).format('YYYY-MM-DD')
    }else if(item == "This Month"){
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.startDate=moment(startOfMonth).format('YYYY-MM-DD');
      this.endDate=moment(today).format('YYYY-MM-DD')
    }else if(item == "This Year"){
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      this.startDate=moment(startOfYear).format('YYYY-MM-DD');
      this.endDate=moment(today).format('YYYY-MM-DD')
    }
    console.log(this.startDate);
    console.log(this.endDate)
    this.getCompleteData();
    this.rangeStartDate = null;
    this.rangeEndDate = null;
  }

  getCompleteData(){
    let filterData={
      "startDate": this.startDate,
      "endDate": this.endDate,
      "activity": this.selectedActivity
    }
    this.spinner.start();
    this.service.retreiveETLMigrationCount(filterData).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.doughnutData.datasets[0].data=[]
        this.doughnutData.labels=[  'Completed','Failed', 'Inprogress']
        this.doughnutChart=new Chart('doughnutChartId',this.doughnutConfig)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        let totalCompletedObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.completedObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        let totalFailedObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.failedObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        let totalInProgressObjectCount = this.getdata.reduce((sum, item) => {
          return sum + (item.inprogressObjectCount ?? 0); // Use 0 if it's null or undefined
        }, 0);
        this.doughnutData.datasets[0].data=[]
        this.doughnutData.labels=[  'Completed '+totalCompletedObjectCount,'Failed '+totalFailedObjectCount, 'Inprogress '+totalInProgressObjectCount]
        this.doughnutData.datasets[0].data=[totalCompletedObjectCount,totalFailedObjectCount,totalInProgressObjectCount]
       if(this.doughnutChart){
        this.doughnutChart.destroy();
       }
        this.doughnutChart=new Chart('doughnutChartId',this.doughnutConfig)
        this.generateLinechart()
        this.service.retreiveLoadObjectsCount(filterData).subscribe(res=>{
          if(res.error == true){
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", {
              duration: 5000,
            });
            this.barchartData.labels=[]
            this.barchartData.datasets[0].data=[]
            this.barchartData.datasets[1].data=[]
            this.barChart=new Chart('barchartId',this.barchartConfig)
          }else{
            console.log(res)
            this.barchartData.labels=[]
            this.barchartData.datasets[0].data=[]
            this.barchartData.datasets[1].data=[]
            let data:any=res
            data.forEach(item=>{
              if(item.totalSuccesscount || item.totalFailcount){
                this.barchartData.labels.push(item.objectname)
                this.barchartData.datasets[0].data.push(item.totalSuccesscount)
                this.barchartData.datasets[1].data.push(item.totalFailcount)
              }
            })
            if(this.barChart){
              this.barChart.destroy();
             }
            this.barChart=new Chart('barchartId',this.barchartConfig)
          }
        })
        this.spinner.stop();
      }
     
    })
  }
  generateLinechart(){
    const labels = [];
    const durations = [];

    for (const item of this.getdata) {
      if(item.state=="Complete" && item.duration){
        labels.push(item.migrationid);
        durations.push(this.convertDurationToMinutes(item.duration));
      }
      
    }
    if(this.lineChart){
      this.lineChart.destroy();
     }
    this.lineChart = new Chart("lineChartId", {
      type: 'line',
  data: {
    labels: labels,
    datasets: [{
      label: 'Job Duration',
      data: durations,
      fill: false,
      borderColor: 'rgb(54, 162, 235)',
      tension: 0.1
    }]
  },
  options: {
    responsive: true,
    maintainAspectRatio: false, 
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            const minutes = context.raw as number;
            return `Duration: ${this.formatDurationFromMinutes(minutes)}`;
          }
        }
      },
      legend: {
        position: 'bottom'
      },
      title: {
        display: true, // 👈 must be true to show title
        text: 'Job Duration',
        font: {
          size: 16,
          weight: 'bold'
        },
        padding: {
          top: 0,
          bottom: 10
        },
        align: 'center' // or 'start' | 'end'
      }
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Duration (Day HH:MM)'
        },
        ticks: {
          callback: (value: number) => {
            return this.formatDurationFromMinutes(value);
          }
        },
        beginAtZero: true
      },
      x: {
        title: {
          display: true,
          text: 'Migration ID'
        }
      }
    }
  }
    });
  }

  convertDurationToMinutes(duration: string): number {
    if (!duration) return 0;

  const parts = duration.split(' ');
  let totalMinutes = 0;

  for (let i = 0; i < parts.length; i += 2) {
    const value = parseInt(parts[i]);
    const unit = parts[i + 1];

    if (unit === 'd') totalMinutes += value * 1440;
    else if (unit === 'h') totalMinutes += value * 60;
    else if (unit === 'm') totalMinutes += value;
    else if (unit === 's') totalMinutes += value / 60;
  }

  return Math.round(totalMinutes);
  }

  formatDurationFromMinutes(minutes: number): string {
    const d = Math.floor(minutes / 1440);
    const h = Math.floor((minutes % 1440) / 60);
    const m = Math.floor(minutes % 60);
  
    return `${d}d ${this.padZero(h)}:${this.padZero(m)}`;
  }
  
  padZero(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
  
  onDateRangeChange() {
    console.log('Date range changed:', this.startDate, this.endDate);
    // You can emit an @Output, call API, filter data, etc.
    var momentObj = moment(this.startDate);
    console.log(momentObj.format('YYYY-MM-DD'))
    if(this.rangeStartDate && this.rangeEndDate){
      this.startDate=moment(this.rangeStartDate).format('YYYY-MM-DD')
      this.endDate=moment(this.rangeEndDate).format('YYYY-MM-DD')
      this.getCompleteData()
      this.selectedFilter=""
    }
  }
  onActivityChanged(event){
    console.log(event);
    this.getCompleteData()
  }
  onPaginationChanged() {
  }
}
